import { Component, EventEmitter, Injector, Input, Output, SimpleChanges } from "@angular/core";
import { EnumNames } from '../../../../enums/enum-names';
import { finalize } from "rxjs/operators";
import { appModuleAnimation } from "@shared/animations/routerTransition";
import { AppComponentBase } from "@shared/app-component-base";
import {
  CargoDto,
  CargoServiceProxy,
  CidadeMicrorregiaoDto,
  EnderecoDto,
  EnumDto,
  EnumDtoListResultDto,
  EnumServiceProxy,
  VagaDto,
} from "@shared/service-proxies/service-proxies";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Observable, Subscription } from "rxjs";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import * as moment from "moment";
import { VAGA_CONFIG } from '../vaga-config';
import { SelectItem } from "@shared/components/vitrine/filtro/select-item.interface";
import { JsonDataService } from "@shared/services/json-data.service";
import { StringUtils } from "@shared/helpers/string-utils";

export const MY_FORMATS = VAGA_CONFIG.MY_FORMATS;

@Component({
  selector: "form-sobre-vaga",
  templateUrl: "./form-sobre-vaga.component.html",
  styleUrls: ["./form-sobre-vaga.component.scss"],
  animations: [appModuleAnimation()],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})

export class FormSobreVagaComponent extends AppComponentBase {

  @Input() vaga;
  @Input() view = false;
  @Input() empresaEspecial = false;

  @Input() vagaDuplicada: VagaDto;

  subscriptions: Subscription[] = [];
  saving = false;
  listaCidadesMicrorregioes: CidadeMicrorregiaoDto[]
  oldEndereco: EnderecoDto = new EnderecoDto();

  listaRegimeTrabalho: EnumDto[] = [];
  regimesTrabalho: any[] = [];
  listaModeloTrabalho: EnumDto[] = [];
  selectedRegimeTrabalho: SelectItem = this.getSelectItem();
  modeloTrabalho: EnumDto;
  nomeCargo: string = '';
  cargos: CargoDto[] = [];
  cargo: CargoDto = new CargoDto();

  public Editor = ClassicEditor;
  @Input() texto: string = '';
  @Output() change = new EventEmitter<any>();
  public config = VAGA_CONFIG.EDITOR_CONFIG;

  salarioInvalido: boolean = false;

  constructor(
    injector: Injector,
    private _cargoService: CargoServiceProxy,
    private _enumServiceProxy: EnumServiceProxy,
    private dataService: JsonDataService,
  ) {
    super(injector);
  }

  ngOnInit() {
    this.Editor = ClassicEditor;
    this.config = VAGA_CONFIG.EDITOR_CONFIG;

    if (this.vaga && this.vaga.cidade) {
      this.setEndereco();
      if (this.vaga && this.vaga.cargo)
        this.preencherCargo();
      if (this.vaga && this.vaga.descricao)
        this.preencherDescricao();
    }

    if(this.vaga && (this.vaga.exibirSalario == null || this.vaga.exibirSalario == undefined))
      this.vaga.exibirSalario = false;

    this.getListRegimeTrabalho();
    this.getListModeloTrabalho();
    this.loadCargos();
  }

  setEndereco() {
    this.oldEndereco.cidade = this.vaga.cidade;
    this.oldEndereco.estado = this.vaga.estado;
    this.oldEndereco.bairro = this.vaga.bairro;
    this.oldEndereco.microrregiaoId = this.vaga.microrregiaoId;
  }

  preencherDescricao() {
    this.texto = this.vaga.descricao;
  }

  private load<T>(serviceCall: () => Observable<T>, setter: (data: T) => void): void {
    abp.ui.setBusy();
    serviceCall()
      .pipe(finalize(() => abp.ui.clearBusy()))
      .subscribe(setter);
  }

  loadCargos(): void {
    this.load<CargoDto[]>(() => this._cargoService.getAll(), data => this.cargos = data);
  }

  private getListByEnumName(enumName: string, assignTo: (items: any[]) => void): Subscription {
    return this._enumServiceProxy
      .getByEnumName(enumName)
      .subscribe((result: EnumDtoListResultDto) => {
        assignTo(result.items);
      });
  }

  private getListRegimeTrabalho(): Subscription {
    return this.getListByEnumName(EnumNames.REGIME_TRABALHO_ENUM, (items) => {
      this.listaRegimeTrabalho = items;
      this.regimesTrabalho = this.listaRegimeTrabalho.map((regimeTrabalho: EnumDto) => ({
        item_id: regimeTrabalho.value,
        item_text: regimeTrabalho.name,
      }));
      if (this.vaga && this.vaga.regimeTrabalho != null) {
        let regime = this.regimesTrabalho.find((e) => e.item_id == this.vaga.regimeTrabalho);
        this.selectedRegimeTrabalho = regime;
      }
    });
  }

  private getListModeloTrabalho(): Subscription {
    return this.getListByEnumName(EnumNames.MODELO_TRABALHO_ENUM, (items) => {
      this.listaModeloTrabalho = items;
      if (!StringUtils.isNullOrEmpty(this.vaga.modeloTrabalho)) {
        this.modeloTrabalho = this.vaga.modeloTrabalho
      }
    });
  }

  onCargoDigitado(cargoDigitado: string) {
    this.nomeCargo = cargoDigitado;
    this.changeInput();
  }

  preencherCargo() {
    this.cargo = this.vaga.cargo;
    this.nomeCargo = this.vaga.cargo.nome;
    this.changeInput();
  }

  isDateValid(date: any): boolean {
    return !moment(date).isBefore(moment().startOf('day')) && moment(date).isBefore(moment().startOf('day').add(1, 'year'));
  }

  isEndDateValid(startDate: any, endDate: any): boolean {
    return endDate !== undefined && !moment(startDate).isAfter(moment(endDate)) && moment(endDate).isBefore(moment().add(1, 'year'));
  }

  validarSalario() {
    this.salarioInvalido = this.vaga.salario > 900000;

    if (this.vaga.salario > 900000) {
      this.vaga.salario = null;
    }
    this.changeInput();
  }

  onSelectPcD(value: boolean) {
    this.vaga.pcd = value;
    this.changeInput();
  }
  onSelectExibirVaga(value: boolean) {
    this.vaga.exibirVagas = value;
    this.changeInput();
  }
  onSelectExibirSalario(value: boolean) {
    this.vaga.exibirSalario = value;
    this.changeInput();
  }
  onSelectConfidencial(value: boolean) {
    this.vaga.confidencial = value;
    this.changeInput();
  }

  getSelectItem(item_id: any = null, item_text: string = null): SelectItem {
    return { item_id, item_text };
  }

  onSelectOrTypeRegimeTrabalho(value: SelectItem) {
    this.selectedRegimeTrabalho = value.item_text ? value : this.getSelectItem();
    this.vaga.regimeTrabalho = value.item_id ?? undefined;
    this.changeInput();
  }

  onSelectModeloTrabalho(value: number) {
    this.vaga.modeloTrabalho = value;
    this.changeInput();
  }

  validateNumberInput(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  enderecoChange(endereco: EnderecoDto) {
    this.vaga.cidade = endereco.cidade;
    this.vaga.bairro = endereco.bairro;
    if (endereco.estado) {
      let nomeEstadoSelecionado = this.dataService.getEstadoNome(endereco.estado);
      if (nomeEstadoSelecionado != "" && nomeEstadoSelecionado != undefined) {
        this.vaga.estado = endereco.estado;
        this.vaga.microrregiaoId = endereco.microrregiaoId;
        this.changeInput();
      }
      else {
        abp.notify.error("Estado não encontrado na lista.");
      }
    }
    else if (!endereco.estado && endereco.cidade) {
      abp.notify.error("Informe um estado válido.");
    }
  }

  changeInput(){
    this.change.emit();
  }
}
